var render, staticRenderFns
import script from "./TiptapContent.vue?vue&type=script&lang=js"
export * from "./TiptapContent.vue?vue&type=script&lang=js"
import style0 from "./TiptapContent.styl?vue&type=style&index=0&id=4d80182e&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80182e",
  null
  
)

export default component.exports